import BillingHTTP from 'utils/billing-http';

class DashboardService {
  updateOnboardingDone() {
    return BillingHTTP.putContent('/dashboard-api/v2/students', {
      onboarding_done: true,
    });
  }

  getBillings() {
    return BillingHTTP.getContent('/dashboard-api/v2/billings');
  }

  getCurrentBill(billingId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/billings/${billingId}/bills/current-bill`);
  }

  getDischargedBills(contractId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/contracts/${contractId}/contract_discharge_requests/bills`);
  }

  getOverdueBills(billingId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/billings/${billingId}/bills/overdue-bills`);
  }

  getBill(billId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/bills/${billId}`);
  }

  downloadBillReceipt(billId) {
    return BillingHTTP.downloadPdf(
      `/dashboard-api/v2/bills/${billId}/download-receipt`,
      'Recibo mensalidade Quero Pago',
    );
  }

  getCurrentContract(billingId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/billings/${billingId}/contracts/current`);
  }

  getPaidBills(billingId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/billings/${billingId}/bills/paid-bills`);
  }

  getNotPaidBills(billingId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/billings/${billingId}/bills/not-paid-bills`);
  }

  getInstitution(institutionId) {
    return BillingHTTP.getContent(`/dashboard-api/v2/institutions/${institutionId}`);
  }

  getReenrollment(billingId) {
    return BillingHTTP.getContent('/dashboard-api/v2/reenrollments', { billing_id: billingId });
  }
}

export default new DashboardService();
